import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../style/gibraltar.css';

// Importing images for Montenegro (1-53)
import montenegro1 from '../images/montenegro1.jpeg';
import montenegro2 from '../images/montenegro2.jpeg';
import montenegro3 from '../images/montenegro3.jpeg';
import montenegro4 from '../images/montenegro4.jpeg';
import montenegro5 from '../images/montenegro5.jpeg';
import montenegro6 from '../images/montenegro6.jpeg';
import montenegro7 from '../images/montenegro7.jpeg';
import montenegro8 from '../images/montenegro8.jpeg';
import montenegro9 from '../images/montenegro9.jpeg';
import montenegro10 from '../images/montenegro10.jpeg';
import montenegro11 from '../images/montenegro11.jpeg';
import montenegro12 from '../images/montenegro12.jpeg';
import montenegro13 from '../images/montenegro13.jpeg';
import montenegro14 from '../images/montenegro14.jpeg';
import montenegro15 from '../images/montenegro15.jpeg';
import montenegro16 from '../images/montenegro16.jpeg';
import montenegro17 from '../images/montenegro17.jpeg';
import montenegro18 from '../images/montenegro18.jpeg';
import montenegro19 from '../images/montenegro19.jpeg';
import montenegro20 from '../images/montenegro20.jpeg';
import montenegro21 from '../images/montenegro21.jpeg';
import montenegro22 from '../images/montenegro22.jpeg';
import montenegro23 from '../images/montenegro23.jpeg';
import montenegro24 from '../images/montenegro24.jpeg';
import montenegro25 from '../images/montenegro25.jpeg';
import montenegro26 from '../images/montenegro26.jpeg';
import montenegro27 from '../images/montenegro27.jpeg';
import montenegro28 from '../images/montenegro28.jpeg';
import montenegro29 from '../images/montenegro29.jpeg';
import montenegro30 from '../images/montenegro30.jpeg';
import montenegro31 from '../images/montenegro31.jpeg';
import montenegro32 from '../images/montenegro32.jpeg';
import montenegro33 from '../images/montenegro33.jpeg';
import montenegro34 from '../images/montenegro34.jpeg';
import montenegro35 from '../images/montenegro35.jpeg';
import montenegro36 from '../images/montenegro36.jpeg';
import montenegro37 from '../images/montenegro37.jpeg';
import montenegro38 from '../images/montenegro38.jpeg';
import montenegro39 from '../images/montenegro39.jpeg';
import montenegro40 from '../images/montenegro40.jpeg';
import montenegro41 from '../images/montenegro41.jpeg';
import montenegro42 from '../images/montenegro42.jpeg';
import montenegro43 from '../images/montenegro43.jpeg';
import montenegro44 from '../images/montenegro44.jpeg';
import montenegro45 from '../images/montenegro45.jpeg';
import montenegro46 from '../images/montenegro46.jpeg';
import montenegro47 from '../images/montenegro47.jpeg';
import montenegro48 from '../images/montenegro48.jpeg';
import montenegro49 from '../images/montenegro49.jpeg';
import montenegro50 from '../images/montenegro50.jpeg';
import montenegro51 from '../images/montenegro51.jpeg';
import montenegro52 from '../images/montenegro52.jpeg';
import montenegro53 from '../images/montenegro53.jpeg';

function Montenegro() {
  const navigate = useNavigate();
  const [selectedImageIndex, setSelectedImageIndex] = useState(null);

  // Array of all imported images
  const photos = [
    montenegro1, montenegro2, montenegro3, montenegro4, montenegro5, montenegro6, montenegro7, montenegro8, montenegro9, montenegro10,
    montenegro11, montenegro12, montenegro13, montenegro14, montenegro15, montenegro16, montenegro17, montenegro18, montenegro19, montenegro20,
    montenegro21, montenegro22, montenegro23, montenegro24, montenegro25, montenegro26, montenegro27, montenegro28, montenegro29, montenegro30,
    montenegro31, montenegro32, montenegro33, montenegro34, montenegro35, montenegro36, montenegro37, montenegro38, montenegro39, montenegro40,
    montenegro41, montenegro42, montenegro43, montenegro44, montenegro45, montenegro46, montenegro47, montenegro48, montenegro49, montenegro50,
    montenegro51, montenegro52, montenegro53
  ];

  // Function to handle image click
  const handleImageClick = (index) => {
    setSelectedImageIndex(index);
  };

  // Function to close the modal
  const closeModal = () => {
    setSelectedImageIndex(null);
  };

  // Function to navigate to the previous image
  const goToPrevious = () => {
    setSelectedImageIndex((prevIndex) =>
      prevIndex === 0 ? photos.length - 1 : prevIndex - 1
    );
  };

  // Function to navigate to the next image
  const goToNext = () => {
    setSelectedImageIndex((prevIndex) =>
      prevIndex === photos.length - 1 ? 0 : prevIndex + 1
    );
  };

  return (
    <div className="gibraltar-page">
      <h1>🇲🇪 Montenegro 2022 🇲🇪</h1>
      <button className="back-button" onClick={() => navigate(-1)}>
        &larr; 
      </button>

      <div className="photo-grid">
        {photos.map((photo, index) => (
          <div
            key={index}
            className="photo-item"
            onClick={() => handleImageClick(index)}
          >
            <img src={photo} alt={`Montenegro ${index + 1}`} />
          </div>
        ))}
      </div>

      {/* Modal for displaying the larger image */}
      {selectedImageIndex !== null && (
        <div className="modal" onClick={closeModal}>
          <div className="modal-content">
            <button className="arrow left-arrow" onClick={(e) => { e.stopPropagation(); goToPrevious(); }}>
              &larr;
            </button>
            <img
              src={photos[selectedImageIndex]}
              alt="Selected"
              className="modal-image"
            />
            <button className="arrow right-arrow" onClick={(e) => { e.stopPropagation(); goToNext(); }}>
              &rarr;
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default Montenegro;